import Vue from 'vue'
import VueI18n from 'vue-i18n'
import BaseConfig from '@/config/base.js'

// 按语言代码映射到对应 JsonModule，使用动态 import 做按需加载
const langLoaders = {
  en: () => import(/* webpackChunkName: "lang-en" */ './JsonModule/en.js'),
  pt: () => import(/* webpackChunkName: "lang-pt" */ './JsonModule/pt.js'),
  es: () => import(/* webpackChunkName: "lang-es" */ './JsonModule/es.js'),
  ar: () => import(/* webpackChunkName: "lang-ar" */ './JsonModule/ar.js'),
  tr: () => import(/* webpackChunkName: "lang-tr" */ './JsonModule/tr.js'),
  fr: () => import(/* webpackChunkName: "lang-fr" */ './JsonModule/fr.js'),
  id: () => import(/* webpackChunkName: "lang-id" */ './JsonModule/id.js'),
  de: () => import(/* webpackChunkName: "lang-de" */ './JsonModule/de.js'),
  it: () => import(/* webpackChunkName: "lang-it" */ './JsonModule/it.js'),
  da: () => import(/* webpackChunkName: "lang-da" */ './JsonModule/da.js'),
  uk: () => import(/* webpackChunkName: "lang-uk" */ './JsonModule/uk.js'),
  pl: () => import(/* webpackChunkName: "lang-pl" */ './JsonModule/pl.js'),
  ru: () => import(/* webpackChunkName: "lang-ru" */ './JsonModule/ru.js'),
  th: () => import(/* webpackChunkName: "lang-th" */ './JsonModule/th.js'),
  vi: () => import(/* webpackChunkName: "lang-vi" */ './JsonModule/vi.js'),
  bn: () => import(/* webpackChunkName: "lang-bn" */ './JsonModule/bn.js'),
  he: () => import(/* webpackChunkName: "lang-he" */ './JsonModule/he.js'),
  ro: () => import(/* webpackChunkName: "lang-ro" */ './JsonModule/ro.js'),
  fa: () => import(/* webpackChunkName: "lang-fa" */ './JsonModule/fa.js'),
  ms: () => import(/* webpackChunkName: "lang-ms" */ './JsonModule/ms.js'),
  az: () => import(/* webpackChunkName: "lang-az" */ './JsonModule/az.js')
}

Vue.use(VueI18n)

// 具体语言在应用启动或切换时通过 loadLanguage + setHtmlDir 设置
export const i18n = new VueI18n({
  locale: '',
  messages: {}
})

export async function loadLanguage(lang) {
  let loader = langLoaders[lang]
  if (!loader) {
    loader = langLoaders['en']
    lang = 'en'
  }

  i18n.locale = lang

  // 语言已存在，不再加载
  const existedMessages = i18n.getLocaleMessage(lang)
  if (existedMessages && Object.keys(existedMessages).length > 0) {
    return
  }

  // 语言不存在，动态加载
  const module = await loader()

  i18n.setLocaleMessage(lang, module)
}

// 设置html语言方向
export function setHtmlDir(lang) {
  document.querySelector('html').setAttribute('lang', lang)
  // 右对齐
  if (BaseConfig.rtlLangs.includes(lang)) {
    document.querySelector('html').setAttribute('dir', 'rtl')
  }
  // 左对齐
  else {
    document.querySelector('html').setAttribute('dir', 'ltr')
  }
}
